export default {
  club_name: 'IBF Falun',
  club_name_short: 'IBFF',
  stadium_name: 'Guide Arena',
  staging_url: 'https://falun.api.fangroup.io',
  prod_url: 'https://falun.api.fangroup.io',
  api: '/api',
  facebook: 'ibffalun',
  basename: '/falun',
  club_logo: '/assets/teams/falun.png',
  app_name: 'falun',
  websale_name: 'falun',
  ntb_team_id: 10021,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'falun',
  monolithEnabled: false,
};
